var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [_vm.stateLoader ? _c("ma-loader") : _vm._e()],
        1
      ),
      _c(
        "ma-modal",
        { ref: "minResolutionModal", attrs: { type: "large" } },
        [_c("template", { slot: "modalContent" }, [_c("ma-sm-modal")], 1)],
        2
      ),
      _c("ma-notifications"),
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [_c("router-view")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }